export default "assets/images/quotes-52c9341f.svg";